module.exports = __webpack_public_path__ + "static/img/ais_play.e9f424a5.png";